export class  TrackedCardio {
    id: string = null;
    createdBy: string = null;
    creationDate: string = null;
    lastModifiedBy: string = null;
    lastModifiedDate: string = null;
    sessions: any[] = [];
    trackingCompleted: string = null;
    workout: string = null;
    workoutProgram: string = null;
    workoutProgramTitle: string = null;
    workoutTitle: string = null;
    referenceId?: string = null;
    date?: string;

    constructor (init: Partial<TrackedCardio>){
        Object.assign(this, init);
    }
}